import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
	standalone: true,
	name: 'orderByDateAngular',
	pure: true
})
export class OrderByDatePipe implements PipeTransform {

	transform(value: any[], propertyName: string): any[] {
		if (value && propertyName) {
			return value.sort((a: any, b: any) => a[propertyName] - b[propertyName]);
		}
		else {
			return value;
		}
	}

}
